// Maintenance model
import { differenceInDays } from "date-fns";

import dates from "componentsv2/tools/dates";
import helper from "./calendar/helper";
import proxy from "api/proxy";
import { useStore } from "storev2/formStore";
import funcs from "tools/functions";
import { getStorage } from "store/local";

const searchRooms = async () => {
  const session = getStorage("ctxSession");
  const rolOwner = await helper.getOwnerUser();
  const dom = [];
  if (rolOwner) {
    store.set("owner", true);
    dom.push(["authorized_users", "in", [session.user]]);
  }
  return dom;
};

const getName = (record) => {
  return record.number;
};

function withChangeDate(storeId, record) {
  const { updateForm } = useStore.getState();
  const { active } = record;
  const { start_date, end_date } = active;
  if (start_date && end_date) {
    const days = getDays(start_date, end_date);
    active.total_days = days;
  }
  updateForm(storeId, active);
}

function getDays(arrival, departure) {
  let arrival_date = arrival;
  let departure_date = departure;
  if (typeof arrival === "string") {
    arrival_date = dates.getTrytonDate2Js(arrival);
  }
  if (typeof departure_date === "string") {
    departure_date = dates.getTrytonDate2Js(departure);
  }
  return differenceInDays(departure_date, arrival_date);
}

function assignedInvisible(_, record) {
  return record?.id > 0;
}

async function assignedMethod(rec) {
  rec.kind = "room";
  rec.state = "open";
  delete rec.total_days;
  const record = funcs.recToTryton({ ...rec });
  const res = await proxy.saveQuery({
    model: "maintenance.request_service",
    storeRec: record,
  });
  if (res.error) {
    return res;
  }
  rec.id = res.data[0];
  const assignRes = await proxy.buttonMethod({
    model: "maintenance.request_service",
    method: "assign",
    ids: [rec.id],
  });
  if (assignRes.error) {
    return assignRes;
  }
  return { ...res, ...assignRes };
}

function recReadOnly(record) {
  return record.id > 0;
}

const PRIORITY = [
  { id: "low", name: "Baja" },
  { id: "important", name: "Importante" },
  { id: "urgent", name: "Urgente" },
];

function layout() {
  const ctxView = {
    model: "maintenance.request_service",
    form_action: [], // options: ['edit', 'delete']
    table_action: [], // options: ['open', 'delete', 'edit', 'add']
    form_rec_name: getName,
    fields: {
      start_date: {
        type: "date",
        required: true,
        withChange: withChangeDate,
        readOnly: recReadOnly,
      },
      end_date: {
        type: "date",
        required: true,
        withChange: withChangeDate,
        readOnly: recReadOnly,
      },
      description: {
        type: "text",
        required: true,
        readOnly: recReadOnly,
      },
      room: {
        type: "many2one",
        model: "hotel.room",
        required: true,
        recSearch: searchRooms,
        readOnly: recReadOnly,
      },
      priority: {
        required: true,
        type: "selection",
        options: PRIORITY,
        readOnly: recReadOnly,
      },
      assigned: {
        type: "button",
        label: "maintenance.request_service.confirm",
        onClick: assignedMethod,
        invisible: assignedInvisible,
        color: "green",
        close: true,
        onSuccessMsg: "hotel.rack.lockout_added",
      },
      number: {
        type: "integer",
        readOnly: true,
      },
      total_days: {
        type: "integer",
        readOnly: true,
      },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
        default: "draft",
      },
    },
    list: [
      { name: "room", width: "10%" },
      { name: "start_date", width: "15%" },
      { name: "end_date", width: "15%" },
      { name: "description", width: "15%" },
      { name: "priority", width: "15%" },
    ],
    form: [
      { name: "room" },
      { name: "number" },

      {
        type: "grid",
        name: "prices",
        colSpan: "col-span-1",
        elements: [
          { name: "start_date" },
          { name: "end_date" },
          { name: "total_days" },
        ],
      },
      { name: "priority" },
      { name: "description" },
      { name: "state" },
      { name: "assigned" },
    ],
  };

  return ctxView;
}

export { layout };
